import { useFormContext } from "react-hook-form";
import { Input } from "@/components/ui/input";
import {
  FormField,
  FormItem,
  FormLabel,
  FormControl,
  FormMessage,
} from "@/components/ui/form";
import CountryCodeSelector from "@/components/ui/CountryCodeSelector";

interface PersonalInfoFieldsProps {
  countryCode: string;
  setCountryCode: (value: string) => void;
}

const ApplicationPersonalInfo = ({
  countryCode,
  setCountryCode,
}: PersonalInfoFieldsProps) => {
  const { control } = useFormContext();

  return (
    <div className="font-verona">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <FormField
          control={control}
          name="first_name"
          render={({ field }) => (
            <FormItem>
              <FormLabel htmlFor="firstName">First Name *</FormLabel>
              <FormControl>
                <Input
                  id="firstName"
                  placeholder="Enter your first name"
                  {...field}
                />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
        <FormField
          control={control}
          name="last_name"
          render={({ field }) => (
            <FormItem>
              <FormLabel htmlFor="lastName">Last Name *</FormLabel>
              <FormControl>
                <Input
                  id="lastName"
                  placeholder="Enter your last name"
                  {...field}
                />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
      </div>
      <div className="mt-4">
        <FormField
          control={control}
          name="email"
          render={({ field }) => (
            <FormItem>
              <FormLabel htmlFor="email">Email Address *</FormLabel>
              <FormControl>
                <Input
                  id="email"
                  type="email"
                  placeholder="Enter your email"
                  {...field}
                />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
      </div>
      <div className="mt-4">
        <FormField
          control={control}
          name="phone_number"
          render={({ field }) => (
            <FormItem>
              <FormLabel htmlFor="phoneNumber">
                WhatsApp Phone Number *
              </FormLabel>
              <FormControl>
                <div className="flex flex-col sm:flex-row gap-2">
                  <div className="w-full sm:w-48">
                    <CountryCodeSelector
                      value={countryCode}
                      onValueChange={setCountryCode}
                    />
                  </div>
                  <Input
                    id="phoneNumber"
                    type="tel"
                    placeholder="Enter your WhatsApp number"
                    {...field}
                  />
                </div>
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
      </div>
    </div>
  );
};

export default ApplicationPersonalInfo;
